const types = {
  CHECKBOX: "check_box",
  COLOR: "color",
  NUMBER: "number",
  NUMBER_LABELED: "number_labeled",
  RADIO: "radio",
  BOOLEAN_RADIO: "boolean_radio",
  SIMPLE_TEXT: "input",
  SIMPLE_LABELED_TEXT: "labeled_input",
  SELECT: "select",
  SELECT_LABELED: "select_labeled",
  RANKING: "ranking",
  SIMPLE_TEXTAREA: "simple_textarea",
  TEXTAREA: "textarea",
  FILE: "file",
  DATE: "date",
  DATETIME: "datetime",
  LOCATION: "location",
  JSON_FIELD: "json",
  HIDDEN: "hidden",
};

export default types;
